/* This is currently being called by two components:
   <HistoryCreateComponent />
   <PhotoSearch />
*/
import React, { useEffect, useState }                       from 'react'
import axios                                                from 'axios'
import {
   Button,
   Container,
   Grid,
   Paper,
   TextField,
   Typography
}                                                           from '@material-ui/core'
import EditPhotoFieldsComponent                             from './EditPhotoFieldsComponent'
import                                                      './PhotoSearch.css'
import MySelect                                             from './MySelect'
import { node_server }                                      from '../Helpers'
import {
   CLIENT_PUBLIC_TOKEN,
   photoSearchOptions,
   superUserPhotoSearchOptions
}                                                           from '../config'
import PropTypes                                            from 'prop-types'
import SnackBar                                             from '../Atoms/SnackBar'
import { store }                                            from '../Redux/Store'

const PhotoSearchComponent = ({ buttonLabel, handleAddPhoto }) => {

   const { superUser } = store.getState()

   const [ caption,              setCaption              ] = useState('')
   const [ fullFilename,         setFullFilename         ] = useState('')
   const [ id,                   setId                   ] = useState('')
   const [ photos,               setPhotos               ] = useState([])
   const [ openEditPhoto,        setOpenEditPhoto        ] = useState(false)
   const [ narrowPhotoTags,      setNarrowPhotoTags      ] = useState('')
   const [ photoTags,            setPhotoTags            ] = useState([])
   const [ searchText,           setSearchText           ] = useState('')
   const [ selectedSearchOption, setSelectedSearchOption ] = useState('')
   const [ showOnePhoto,         setShowOnePhoto         ] = useState(false)
   const [ snackBarMessage,      setSnackBarMessage      ] = useState('')
   const [ snackBarOpen,         setSnackBarOpen         ] = useState(false)
   const [ snackBarType,         setSnackBarType         ] = useState('')
   const [ tag,                  setTag                  ] = useState('')

   const handleSnackBar = ({msg, type}) => {
      setSnackBarMessage(msg)
      setSnackBarType(type)
      setSnackBarOpen(true)
      setTimeout(() => {
         setSnackBarOpen(false)
         setSnackBarMessage('')
         setSnackBarType('')
         setOpenEditPhoto(false)
      }, 2500)
   }

   /* What does this do? Gets photoTags for display and selection? */
   useEffect( () => {
      fetchData()
      async function fetchData() {
         axios.defaults.headers.common = {Accept: "application/json, text/plain, */*", 'Authorization': `Bearer ${CLIENT_PUBLIC_TOKEN}`}
         await axios.get( node_server + 'photo/photoTag/photoTags' )
            .then( res => {
               setPhotoTags(res.data)
               axios.defaults.headers.common = {Accept: "application/json, text/plain, */*"}
            } )
      }
   }, [])

   useEffect( () => {
      fetchData()
      async function fetchData() {
         if (selectedSearchOption === 'Show Photos that need Approval' ) {
            axios.defaults.headers.common = {Accept: "application/json, text/plain, */*", 'Authorization': `Bearer ${CLIENT_PUBLIC_TOKEN}`}
            await axios.get( node_server + 'photo/notApproved' )
               .then( res => {
                  setPhotos(res.data)
                  if (res.data.length === 0 && selectedSearchOption !== '') {
                     setSnackBarMessage('There are no photos that match that request')
                     setSnackBarType('error')
                     handleSnackBar()
                  }
                  axios.defaults.headers.common = {Accept: "application/json, text/plain, */*"}
               }
            )
         }
      }
  }, [selectedSearchOption] )

  
   const selectedOption = (e) => {
      setSelectedSearchOption(e.target.value)
      setPhotos([])
      setOpenEditPhoto(false)
   }
   
   const handleApprove = (id) => {
      axios.put(node_server + 'photo/approve', {
         CLIENT_PUBLIC_TOKEN,
         id
      })
         .then( res => {
            setPhotos(res.data)
         } )
   }

   const handleCloseOnePhoto = () => {
      setShowOnePhoto(false)
   }

   const handleEdit = async (id) => {
      let photoTags = ''
      axios.defaults.headers.common = {Accept: "application/json, text/plain, */*", 'Authorization': `Bearer ${CLIENT_PUBLIC_TOKEN}`}
      await axios.get(node_server + `photo/${id}`)
         .then( res => {
            const len = res.data.photoTags.length
            
            res.data.photoTags.forEach((element,i) => {
               if (i < len - 1) {
                  photoTags = photoTags + element.tagText + ','
               }
               else {
                  photoTags = photoTags + element.tagText 
               }
            });
            setCaption(res.data.caption)
            setFullFilename(res.data.fullFilename)
            setId(res.data._id)
            axios.defaults.headers.common = {Accept: "application/json, text/plain, */*"}
         })
      setOpenEditPhoto(true)
   }
   
   const handleSearchText = (e) => {
      setSearchText(e.target.value)
   }
   
   const handleSelect = (fullFilename, caption) => {
      setFullFilename(fullFilename)
      setCaption(caption)
      setShowOnePhoto(true)
   }
   
   const handleSubmit = (id) => {
      axios.defaults.headers.common = {Accept: "application/json, text/plain, */*", 'Authorization': `Bearer ${CLIENT_PUBLIC_TOKEN}`}
      axios.get( node_server + `photo/caption/${searchText}` )
         .then( res => {
            setPhotos(res.data)
            if (res.data.length === 0 && selectedSearchOption !== '') {
               handleSnackBar()
               axios.defaults.headers.common = {Accept: "application/json, text/plain, */*"}
            }
         }
      )
   }
   
   const handleSearchByTag = async (tag) => {
      setTag(tag)
      axios.defaults.headers.common = {Accept: "application/json, text/plain, */*", 'Authorization': `Bearer ${CLIENT_PUBLIC_TOKEN}`}
      await axios.get( node_server + `photo/photoTag/${tag}` )
      .then( res => {
         setPhotos(res.data)
         if (res.data.length === 0 && selectedSearchOption !== '') {
            handleSnackBar()
            axios.defaults.headers.common = {Accept: "application/json, text/plain, */*"}
         }
      }
      )
   }
   
   const narrowPhotoTagDisplay = (e) => {
      setNarrowPhotoTags(e.target.value)
   }

   const photosToDisplay = photos.map( p => {
      const dataTestId = 'add-to-entry-' + `${p._id}`
      return(
         <Grid container key={p._id} >
            <Grid style={{ width: "25%", height: "25%" }}>
               <img alt={p.caption} src={p.smallFilename} style={{ width: "100%", height: "100%" }} onClick={() => handleSelect(p.fullFilename, p.caption)} />
            </Grid>
            <Grid style={{ width: "65%" }}>
               <Typography style={{ textAlign: 'left', marginTop: '1rem', marginLeft: '1rem' }} >
                  {p.caption}
               </Typography>
            </Grid>
            {superUser
               ?
               <Grid>
                  <Grid>
                     <Button variant="contained" color="primary" onClick={() => handleApprove(p._id)}>
                        Approve
                     </Button>
                  </Grid>
                  <Grid>
                     <Button data-testid={dataTestId} variant="contained" color="primary" onClick={() => handleAddPhoto({ caption: p.caption, id: p._id, filename: p.fullFilename })}>
                        { buttonLabel }
                     </Button>
                  </Grid>
                  <Grid style={{marginTop: '2rem'}} >
                     <Button variant="contained" color="primary" onClick={() => handleEdit(p._id)}>
                        Edit
                     </Button>
                  </Grid>
               </Grid>
               :
               null
            }
         </Grid>
      )
   })

   const photoTagsToDisplay = photoTags.map( t => {
      if (t.includes(narrowPhotoTags)) {
         return (
            <Grid key={t} >
               <Typography align='left' style={{marginLeft: '1rem'}} onClick={() => handleSearchByTag(t)}>
                  {t}
               </Typography>
            </Grid>
         )
      }
      return true
   })

   return (
      <Container style={{ marginTop: '5rem' }}>
         <Grid >
            {superUser
               ?
               <Grid data-testid='photo-search-options-dropdown' >
                  <MySelect label="Search Options" name="searchSelection" options={superUserPhotoSearchOptions} selectedOption={selectedOption} value={selectedSearchOption} />
               </Grid>
               :
               <Grid data-testid='photo-search-options-dropdown' >
                  <MySelect label="Search Options" name="searchSelection" options={photoSearchOptions} selectedOption={selectedOption} value={selectedSearchOption} />
               </Grid>
            }

            {selectedSearchOption === 'Search Photo Captions'
               ?
               <Grid item xs={12} sm={4} style={{width: '33%'}} >
                  <TextField
                     label='Search Terms'
                     name='search-terms-input'
                     onChange={handleSearchText}
                     style={{width: '300px'}}
                     variant='outlined'
                  />
                  <Grid>
                     {searchText === ''
                        ?
                           <Button variant="contained" color="primary" onClick={() => handleSubmit()} disabled>
                              Submit
                           </Button>
                        :
                           <Button variant="contained" color="primary" onClick={() => handleSubmit()}>
                              Submit
                           </Button>
                     }
                  </Grid>
               </Grid>
               :
               null
            }

            {selectedSearchOption === 'Search by Photo Tag'
               ?
               <div style={{marginBottom: '1rem', width: '100%'}} >
                  <Grid container >
                     <Grid container item xs={12} style={{ alignItems: 'flex-start', width: '25%', marginBottom: '1rem' }} >
                        <TextField
                           label='Search Tags For:'
                           name='search-photo-tags-input'
                           onChange={narrowPhotoTagDisplay}
                           style={{width: '430px'}}
                           variant='outlined'
                        />
                     </Grid>
                     <Grid style={{ width: '35%' }} >
                        <Paper className='photoTags' style={{ backgroundColor: "rgba(0, 0, 255, 0.05)" }} >
                           <Grid>
                              { photoTagsToDisplay }
                           </Grid>
                        </Paper>
                     </Grid>
                  <Grid style={{ width: '65%' }} >
                     <Typography variant='h6' style={{ textAlign: 'left', marginLeft: '1rem', marginTop: '2rem' }} >
                        Tag: { tag }
                     </Typography>
                  </Grid>
                  </Grid>
               </div>
               :
               null
            }

            {photos.length > 0 && !showOnePhoto && !openEditPhoto
               ?
               <Grid>
                  { photosToDisplay }
               </Grid>
               :
               null
            }
            {photos.length > 0 && showOnePhoto
               ?
               <Grid container style={{marginBottom: '5rem'}}>
                  <Grid style={{ width: "100%", height: "100%" }}>
                     <img alt={caption} src={fullFilename} style={{ width: "100%", height: "100%" }} />
                  </Grid>
                  <Grid style={{ width: "100%" }}>
                     <Typography style={{ textAlign: 'center', marginTop: '1rem', marginLeft: '1rem' }} >
                        {caption}
                     </Typography>
                  </Grid>
                  <Grid container justifyContent="center" style={{ marginTop: "2rem" }} >
                     <Button variant="contained" color="primary" onClick={() => handleCloseOnePhoto()}>
                        Close
                     </Button>
                  </Grid>
               </Grid>
               :
               null
            }
         </Grid>
         <Grid container justifyContent="center" style={{ marginTop: "2rem" }}>
            <Grid item sm={6}>
               {snackBarOpen ?
                  <SnackBar msg={snackBarMessage} type={snackBarType} />
                  :
                  null
               }
            </Grid>
         </Grid>
         <Grid>
            {openEditPhoto
               ?
               <EditPhotoFieldsComponent
                  handleSnackBar={handleSnackBar}
                  id={id}
                  title={'Edit Photo Page'}
               />
               :
               null
            }
         </Grid>

         {snackBarOpen ?
            <Grid container justifyContent="center" style={{ marginTop: "2rem" }}>
               <Grid item sm={6}>
                     <SnackBar msg={'There are no photos that match that request'} type={'success'} />
               </Grid>
            </Grid>
            : null
         }
      </Container>
   )

}

export default PhotoSearchComponent

PhotoSearchComponent.propTypes = {
   buttonLabel:      PropTypes.string,
   handleAddPhoto:   PropTypes.func
}